module.exports = __webpack_public_path__ + "img/nor_kh_moun1.39193530.png";